import Vue from 'vue'
import Router from 'vue-router'
import Index from '../components/Index'
import Login from '../components/Users/Login'
import AcceptInvitation from '../components/Users/AcceptInvitation'
import ResetPassword from '../components/Users/ResetPassword'
import VerifyEmail from '../components/Users/VerifyEmail'
import Signup from '../components/Users/Signup'
import Bills from '../components/Setting/Bills'
import Dashboard from '../components/Dashboard'

import Deal from '../components/Deals/SalesManagement'
import DealFinance from '../components/Deals/DealFinance'
import DealManagement from '../components/Deals/DealManagement'

import SetStages from '../components/Setting/SetStages'
import Company from '../components/Setting/Company'
import Members from '../components/Setting/Members'
import CreditCardBinding from '../components/Setting/CreditCardBinding'
import ActivityCategories from '../components/Setting/ActivityCategories'
import IssuesCategories from '../components/Setting/IssuesCategories'

import UserProfile from '../components/Users/UserProfile'
import OrganizationList from '../components/Organizations/OrganizationList'
import Organization from '../components/Organizations/Organization'
import ContactList from '../components/Contacts/ContactList'
import Contact from '../components/Contacts/Contact'
import ActivityList from '../components/Activities/ActivityList'
import ProductList from '../components/ProductList'
import QuotationView from '../components/Quotation/QuotationView'
import AnalyticsSales from '../components/Analytics/Sales'
import AnalyticsClients from '../components/Analytics/Clients'

import FinanceList from '../components/Finances/FinanceList'
import FixedMoney from '../components/Finances/FixedMoney'
import MoneyCategories from '../components/Finances/MoneyCategories'
import YearBudget from '../components/Finances/YearBudget'
import IncomeStatement from '../components/Finances/IncomeStatement'
import CashFlow from '../components/Finances/CashFlow'
import CashFlowEstimate from '../components/Finances/CashFlowEstimate'
import CashFlowHistory from '../components/Finances/CashFlowHistory'

import ProjectsListBoard from '../components/ProjectManage/ProjectsListBoard'

import KnowledgeBaseBoard from '../components/KnowledgeBase/KnowledgeBaseBoard'




Vue.use(Router)
export default new Router({
  mode: 'history',
    routes: [{
        path: '/',
        redirect: '/dashboard'
    },{
        name: 'login',
        path: '/login',
        component: Login
    },{
        name: 'accept_invitation',
        path: '/accept_invitation',
        component: AcceptInvitation
    },{
        name: 'reset_password',
        path: '/reset_password',
        component: ResetPassword
    },{
        name: 'verify_email',
        path: '/verify_email',
        component: VerifyEmail
    },{
        name: 'index',
        path: '/index',
        component: Index
    },{
        name: 'signup',
        path: '/signup',
        component: Signup
    },{
        name: 'dashboard',
        path: '/dashboard',
        component: Dashboard
    },{
        name: 'deal',
        path: '/deal/:deal_token',
        component: Deal
    },{
        name: 'bills',
        path: '/setting/bills',
        component: Bills
    },{
        name: 'set_stages',
        path: '/setting/set_stages',
        component: SetStages
    },{
        name: 'company',
        path: '/setting/company',
        component: Company
    },{
        name: 'members',
        path: '/setting/members',
        component: Members
    },{  
        name: 'credit_card_binding',
        path: '/setting/credit_card_binding',
        component: CreditCardBinding
    },{  
        name: 'activity_categories',
        path: '/setting/activity_categories',
        component: ActivityCategories  
    },{ 
        name: 'issues_categories',
        path: '/setting/issues_categories',
        component: IssuesCategories
    },{ 
        name: 'user_profile',
        path: '/user_profile',
        component: UserProfile
    },{
        name: 'organizations',
        path: '/organizations',
        component: OrganizationList
    },{
        name: 'organization',
        path: '/organization/:organization_token',
        component: Organization
    },{
        name: 'contacts',
        path: '/contacts',
        component: ContactList
    },{
        name: 'contact',
        path: '/contact/:contact_token',
        component: Contact
    },{
        name: 'activities',
        path: '/activities',
        component: ActivityList
    },{
        name: 'products',
        path: '/products',
        component: ProductList
    },{
        name: 'show_quotation',
        path: '/quotation/:quotation_token',
        component: QuotationView
    },{
        name: 'analytics_sales',
        path: '/analytics/sales',
        component: AnalyticsSales
    },{
        name: 'analytics_clients',
        path: '/analytics/clients',
        component: AnalyticsClients
    },{
        name: 'finance_list',
        path: '/finances/finance_list',
        component: FinanceList
    },{
        name: 'fixed_money',
        path: '/finances/fixed_money',
        component: FixedMoney
    },{
        name: 'money_categories',
        path: '/finances/money_categories',
        component: MoneyCategories
    },{
        name: 'year_budget',
        path: '/finances/year_budget',
        component: YearBudget
    },{
        name: 'income_statement',
        path: '/finances/income_statement',
        component: IncomeStatement
    },{
        name: 'cashflow',
        path: '/finances/cashflow',
        component: CashFlow
    },{
        name: 'cashflow_estimate',
        path: '/finances/cashflow_estimate',
        component: CashFlowEstimate
    },{
        name: 'cashflow_history',
        path: '/finances/cashflow_history',
        component: CashFlowHistory
    },{
        name: 'deal_finance',
        path: '/deals/deal_finance/:deal_token',
        component: DealFinance
    },{
        name: 'deal_management',
        path: '/deals/deal_management/:deal_token',
        component: DealManagement
    },{
        name: 'projects_list_board',
        path: '/projects_list_board',
        component: ProjectsListBoard
    },{
        name: 'knowledge_base',
        path: '/knowledge_base',
        component: KnowledgeBaseBoard
    }

    ]
});



// WEBPACK FOOTER //
// ./src/router/index.js